/* WizeBand Halloween landing (homepage look): countdown eyebrow, US cut-off, design rail arrows, one-tap sets.
   Cards, size, set bar, FAQ and cart count come from wb-lp-v3.js. */
(function(){
  var root = document.getElementById('lp3'); if(!root || !root.classList.contains('hw')) return;
  var toast = document.getElementById('lp3-toast'), toastT;
  function showToast(msg){ if(!toast) return; toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function(){ toast.classList.remove('is-on'); }, 2800); }
  function parseDay(s){ var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((s||'').trim()); return m ? new Date(+m[1], +m[2]-1, +m[3]) : null; }
  var now = new Date(); var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  /* countdown in the hero eyebrow */
  var cnt = root.querySelector('[data-hw-count]');
  if(cnt){
    var target = parseDay(cnt.getAttribute('data-date'));
    if(target){
      var days = Math.round((target - today) / 86400000);
      var t = null;
      if(days > 1) t = (cnt.getAttribute('data-many')||'').replace('[n]', days);
      else if(days === 1) t = cnt.getAttribute('data-one');
      else if(days === 0) t = cnt.getAttribute('data-day');
      if(t) cnt.textContent = t;
    }
  }

  /* US cut-off line hides itself after the date */
  root.querySelectorAll('[data-hw-cutoff]').forEach(function(el){
    var until = parseDay(el.getAttribute('data-until'));
    if(until && today > until) el.style.display = 'none';
  });

  /* design rail arrows */
  root.querySelectorAll('[data-hw-rail]').forEach(function(rail){
    var track = rail.querySelector('[data-hw-track]'); if(!track) return;
    function step(){ var c = track.querySelector('.hw-card'); return c ? (c.getBoundingClientRect().width + 20) * 2 : 400; }
    var prev = rail.querySelector('[data-hw-prev]'), next = rail.querySelector('[data-hw-next]');
    function upd(){ if(prev) prev.style.visibility = track.scrollLeft > 4 ? 'visible' : 'hidden'; if(next) next.style.visibility = track.scrollLeft + track.clientWidth < track.scrollWidth - 4 ? 'visible' : 'hidden'; }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    track.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
  });

  /* one-tap sets: add all three in the shopper's size */
  function currentSize(){
    var on = root.querySelector('#lp3-size [data-lp3-size].is-on');
    if(on) return parseInt(on.getAttribute('data-lp3-size'), 10) || 1;
    try { return parseInt(localStorage.getItem('wb_lp3_size')||'1', 10) || 1; } catch(e){ return 1; }
  }
  root.querySelectorAll('[data-hw-set]').forEach(function(set){
    var btn = set.querySelector('[data-hw-set-add]'); var label = set.querySelector('[data-hw-set-label]');
    if(!btn || !label) return; var base = label.textContent;
    btn.addEventListener('click', function(){
      var ids = (set.getAttribute(currentSize() === 2 ? 'data-ids2' : 'data-ids1') || '').split(',').map(function(x){ return parseInt(x, 10); }).filter(Boolean);
      if(!ids.length) return;
      btn.classList.add('is-busy'); label.textContent = 'Adding…';
      fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: ids.map(function(id){ return {id:id, quantity:1}; })})})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
        .then(function(res){
          btn.classList.remove('is-busy');
          if(!res.ok){ label.textContent = base; showToast(res.j && res.j.description ? res.j.description : 'Could not add. Please try again.'); return; }
          btn.classList.add('is-added'); label.textContent = 'Added ✓';
          setTimeout(function(){ btn.classList.remove('is-added'); label.textContent = base; }, 2400);
          var item = res.j && res.j.items ? res.j.items[res.j.items.length - 1] : res.j;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, addToCartBtn:btn}}));
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function(){ btn.classList.remove('is-busy'); label.textContent = base; });
    });
  });
})();
